/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SourcingSearchFreelancer } from './';
import {
    SourcingSearchFreelancerFromJSON,
    SourcingSearchFreelancerFromJSONTyped,
    SourcingSearchFreelancerToJSON,
} from './';

/**
 * 
 * @export
 * @interface SourcingSearchResponse
 */
export interface SourcingSearchResponse {
    /**
     * 
     * @type {Array<SourcingSearchFreelancer>}
     * @memberof SourcingSearchResponse
     */
    results: Array<SourcingSearchFreelancer>;
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchResponse
     */
    totalElements: number;
}

/**
 * Check if a given object implements the SourcingSearchResponse interface.
 */
export function instanceOfSourcingSearchResponse(value: object): value is SourcingSearchResponse {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    return true;
}

export function SourcingSearchResponseFromJSON(json: any): SourcingSearchResponse {
    return SourcingSearchResponseFromJSONTyped(json, false);
}

export function SourcingSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(SourcingSearchFreelancerFromJSON)),
        'totalElements': json['totalElements'],
    };
}

export function SourcingSearchResponseToJSON(value?: SourcingSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'results': ((value['results'] as Array<any>).map((v) => SourcingSearchFreelancerToJSON(v))),
        'totalElements': value['totalElements'],
    };
}

